import React, { FC, memo } from 'react'

import { Button } from '@/components/Button/Button'
import { useCommonTranslation } from '@/i18n/useCommonTranslation'

import { RetryButtonElem } from './styles'

const RetryButtonRaw: FC<{ action: () => void }> = ({ action }) => {
  const { t } = useCommonTranslation()
  return (
    <RetryButtonElem>
      <Button text={t('retry')} onClick={() => action()} />
    </RetryButtonElem>
  )
}

export const RetryButton = memo(RetryButtonRaw)
